import { CKButton, CKModal, CKTextFieldNext } from 'clearkit';

import { ButtonContainer } from '~/components/unified/ButtonContainer';

import { useProspector } from '../useProspector';

export function RenameProspectList() {
  const [state, send] = useProspector();

  const isOpen = state.matches('renaming');

  return (
    <CKModal isVisible={isOpen}>
      <CKModal.Header>
        <CKModal.Heading>Rename list</CKModal.Heading>
      </CKModal.Header>
      <CKModal.Body className="p-6 space-y-4">
        <p className="text-base">
          Give <strong>{state.context.name || 'Unnamed Prospect List'}</strong>{' '}
          a new name.
        </p>
        <CKTextFieldNext
          autoFocus
          onChange={(value) => send('UPDATE_NAME', { value })}
          placeholder="List name"
          value={state.context.name}
        />
      </CKModal.Body>
      <CKModal.Footer>
        <ButtonContainer>
          <CKButton
            isDisabled={state.matches('saving')}
            onClick={() => send('CANCEL')}
          >
            Cancel
          </CKButton>
          <CKButton
            isDisabled={!state.context.name}
            onClick={() => send('SAVE')}
            variant="bold"
            variantColor="blue"
          >
            Rename list
          </CKButton>
        </ButtonContainer>
      </CKModal.Footer>
    </CKModal>
  );
}
